export default (() => {
    const elements = Array.from(document.querySelectorAll('.js-transfer-element'));

    elements.forEach((el) => {
        const wrapper = document.querySelector(`#${el.dataset.target}`);

        if (wrapper) {
            el.classList.add('transfered');
            wrapper.innerHTML = el.outerHTML;
            el.remove();
        }
    });
})();
